import React from 'react';
import { Button } from 'antd';
import cx from 'classnames';
import styles from './index.module.css';
import { ChevronLeft } from 'lucide-react';
import HelpArticleButton from 'appJS/utils/HelpArticleButton';
import { InfoCircleOutlined, SettingOutlined } from '@ant-design/icons';
import GreenTick from './images/ic-green-tick.svg';
import { visibleModals, VisibleModal } from './index';
import { integrationsInfo } from './integrationsInfo';
import { IntegrationIcon } from './integrationIcon';

const ConnectedButton = ({ show }: { show: boolean }) =>
  show && (
    <Button type="text" className={styles.connectedButton} icon={<GreenTick />}>
      Connected
    </Button>
  );

const ConnectButton = ({
  show,
  handleConnect
}: {
  show: boolean;
  handleConnect?: () => void;
}) =>
  show && (
    <Button type="primary" onClick={handleConnect}>
      Connect
    </Button>
  );

export const ModalComplexHeader = ({
  show,
  showConnect,
  isConnected,
  handleConnect,
  manageUrl,
  visibleModal,
  setVisibleModal
}: {
  show: boolean;
  showConnect?: boolean;
  isConnected?: boolean;
  handleConnect?: () => void;
  manageUrl?: string | null;
  visibleModal: VisibleModal | null;
  setVisibleModal: (modal: VisibleModal | null) => void;
}) => {
  if (!show) return null;
  // TODO: this will need to be removed at some stage
  const title = visibleModal?.includes('native')
    ? visibleModal.replace('native', '')
    : visibleModal;

  const integrationInfo = visibleModal
    ? integrationsInfo[visibleModal as keyof typeof integrationsInfo]
    : null;

  return (
    <div className={styles.header}>
      <div
        className={cx(styles.headerContainer, {
          [styles.hasConnectButton]: showConnect
        })}
      >
        <div>
          <span className={styles.headerLogoContainer}>
            <IntegrationIcon
              show={!!(integrationInfo && visibleModal)}
              name={integrationInfo?.label || ''}
              icon={integrationInfo?.icon}
              integrationName={visibleModal || ''}
            />
          </span>
          <span className={styles.headerTitle}>
            <span className={styles.integrationTitle}>{title}</span>
            <span className={styles.headerActions}>
              <Button
                type="text"
                className={styles.backLink}
                onClick={() => setVisibleModal(null)}
                icon={<ChevronLeft className={styles.chevronIcon} />}
              >
                Back
              </Button>
              <HelpArticleButton
                articleId={visibleModal ? visibleModals[visibleModal] : ''}
              >
                <Button
                  type="text"
                  className={styles.helpArticleButton}
                  icon={<InfoCircleOutlined className={styles.helpIcon} />}
                >
                  Help guide
                </Button>
              </HelpArticleButton>
              {manageUrl && (
                <Button
                  type="text"
                  className={styles.manageIntegrationButton}
                  href={manageUrl}
                  icon={<SettingOutlined className={styles.manageIcon} />}
                >
                  Manage
                </Button>
              )}
            </span>
          </span>
        </div>
        <div className={cx({ [styles.connected]: isConnected })}>
          <ConnectedButton show={!!isConnected} />
          <ConnectButton
            show={isConnected === false}
            handleConnect={handleConnect}
          />
        </div>
      </div>
      <span className={styles.headerBackground} />
    </div>
  );
};
